import { routerStyxie } from '@/router/styxieBridge'

// Report configurations is client-side routed: every action boots the shared
// router shell. No styxie payload — the pages fetch their bootstrap through
// GET /api/report_configurations/page_meta (feature-level) and
// GET /api/report_configurations/:id (edit form record) in route `prepare`.
Styxie.Initializers.ReportConfigurations = routerStyxie({ actions: ['index', 'new', 'edit']})
